<template>
<div class="bb-list-county-flags">
  <CountryFlag v-for="(passport, passIndex) in firstTwoFlags"
               :key="passport.number + passport.citizenship + passIndex"
               v-if="passport.citizenship"
               :countryId="passport.citizenship"/>
  <template v-if="passports.length === 3">
    <CountryFlag v-if="thirdFlag.citizenship"
                 :countryId="thirdFlag.citizenship"/>
  </template>
  <template v-else-if="passports.length > 3">
    <div class="bb-list-county-flags-more">
      <button class="bb-list-county-flags-more-button"
              v-click-outside="closePopup"
              @click.stop="showMore = !showMore">
        <span>+{{countFlags}}</span>
        <i class="icon-show-more bb-list-county-flags-more-button__icon"/>
      </button>
      <transition name="bounce">
        <div class="bb-list-county-flags-more-popup" v-if="showMore" @mouseleave="closePopup">
          <div class="bb-list-county-flags-more-popup-item"
               v-for="(passport, passIndex) in passports"
               v-if="passport.citizenship && passIndex > 1"
               :key="passport.number + passport.citizenship + passIndex">
            <CountryFlag :countryId="passport.citizenship" :hide-popup="true"/>
            <span class="bb-list-county-flags-more-popup-item__name">
            {{getCountryName(passport.citizenship)}}
          </span>
          </div>
        </div>
      </transition>
    </div>
  </template>
</div>
</template>

<script>
import CountryFlag from '@/components/Main/CountryFlag/CountryFlag'
import {find, take, get} from 'lodash'
import countriesList from '@/constants/countriesList'

export default {
  name: 'ListCountyFlags',
  components: {CountryFlag},
  props: {
    passports: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showMore: false
    }
  },
  computed: {
    firstTwoFlags () {
      return take(this.passports, 2)
    },
    thirdFlag () {
      return this.passports[2] || {}
    },
    countFlags () {
      return this.passports.length - 2
    }
  },
  methods: {
    getCountryName (countyId) {
      const country = find(countriesList, {id: countyId})
      return get(country, 'name', '')
    },
    closePopup () {
      this.showMore = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-list-county-flags {
  @include global-font;
  display: grid;
  grid-template-columns: repeat(auto-fill, 22px);
  grid-gap: 5px;
  align-items: center;
  height: 22px;

  &-more {
    position: relative;

    &-button {
      display: flex;
      align-items: center;
      white-space: nowrap;
      color: $color-silver-chalice;
      font-size: 14px;
      transition: 0.3s;
      cursor: pointer;

      &__icon {
        margin-left: 2px;
        font-size: 8px;
      }

      &:hover {
        opacity: 0.7;
      }
    }

    &-popup {
      position: absolute;
      left: 0;
      top: 26px;
      padding: 12px;
      background: $color-white;
      box-shadow: 0 0 10px rgba($color-black, 0.1);
      border-radius: 4px;
      z-index: 99;
      transition: 0.3s;

      &-item {
        display: flex;
        align-items: center;

        &__name {
          margin-left: 6px;
          font-size: 14px;
          white-space: nowrap;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/CountryFlag/ListCountyFlags.vue